import React from 'react';
import { Card } from 'react-bootstrap';

import GenericCardRenderItems from './GenericCardRenderItems';
import CartaPorteRegimenesAduanerosListDescription from '../cartaporte/CartaPorteRegimenesAduanerosListDescription';

const ComplementoCartaPorteRegimenesAduanerosResumen = ({ data = {}, onEdit, onDelete }) => {
  const render = (item) => (
    <GenericCardRenderItems
      key={item.id}
      data={item}
      labels={labels}
    />
  );

  return (
    <>
      {data.RegimenesAduaneros?.RegimenAduaneroCCP.length > 0 && (
        <>
          <div className="d-block mt-3 mb-2">
            <strong>Regímenes Aduaneros</strong>
          </div>

          <Card className="mb-2">
            <Card.Body>{data.RegimenesAduaneros.RegimenAduaneroCCP.map(render)}</Card.Body>
          </Card>
        </>
      )}
    </>
  );
};

const labels = [
  {
    label: 'Clave',
    index: 'RegimenAduanero',
  },
  {
    label: 'Descripción',
    index: 'id',
    render: (value, data) => {
      return <CartaPorteRegimenesAduanerosListDescription data={data} />;
    },
  },
];

export default ComplementoCartaPorteRegimenesAduanerosResumen;
